<template>
  <div class="infor fl">
    <all-header
      :label="'证书信息公布'"
      :ischage="true"
      :sublabel="'返回记录列表'"
      @getvalue="goBack"></all-header>
    <div class="infor-c">
      <div class="publicity-header">
        <div class="progress-bar">
          <div class="progress-text">
            <span class="progress-label">当前申报节点：</span>
            <span class="progress-value">{{ latestAuditDisplay }}</span>
          </div>
          <div class="progress-actions">
            <el-button
              v-if="showRejectReasonBtn"
              size="mini"
              class="btn-reject"
              @click="openRejectReason"
            >驳回理由</el-button>
            <el-button size="mini" class="btn-log" @click="goAuditLogs">查看审核</el-button>
          </div>
        </div>
      </div>

      <el-dialog
        title="温馨提示"
        :visible.sync="rejectReasonVisible"
        width="474px"
        :before-close="closeRejectReason"
      >
        <div class="yellow-box reject-reason-box">
          {{ latestRejectReason || '暂无驳回理由' }}
        </div>
      </el-dialog>

      <div v-if="mode === 'modify'" class="modify-panel">
        <div class="field-group">
          <label>联系人：</label>
          <el-input v-model="modifyRequest.contact" placeholder="请输入" />
        </div>
        <div class="field-group">
          <label>联系电话：</label>
          <el-input v-model="modifyRequest.phone" placeholder="请输入" />
        </div>
        <div class="field-group file-upload">
          <label>申请附件：</label>
          <el-upload
            class="file-upload-area"
            :action="uploadUrl"
            :data="{ token }"
            accept=".doc,.docx,.pdf,.jpg,.png,.zip,.rar"
            :file-list="modifyRequest.fileList"
            :on-success="onUploadSuccess"
            :on-remove="onUploadRemove"
            :on-error="onUploadError"
            :limit="5"
            list-type="text"
          >
            <div class="file-box">
              <img src="@/assets/gsadd.png" alt="upload" />
            </div>
            <div class="file-note">申请说明需加盖公司公章</div>
          </el-upload>
        </div>
        <div class="field-group">
          <label>申请说明：</label>
          <el-input
            type="textarea"
            :rows="3"
            v-model="modifyRequest.reason"
            placeholder="请说明需要修改的内容及原因"
          ></el-input>
        </div>
        <div class="action-row">
          <el-button class="btn-modify" @click="mode = 'view'">返回查看</el-button>
          <el-button class="btn-confirm" :loading="submitting" @click="submitModifyRequest">提交</el-button>
        </div>
      </div>

      <div v-else>
        <div class="publicity-table">
          <div class="table-head">
            <div class="table-head__result">
              <img class="table-head__icon" src="/imgs/rcicon.png" alt="评审结果" />
              <span class="table-head__label">评审结果：</span>
              <span class="table-head__value">{{ reviewResultDisplay }}</span>
            </div>
            <div class="deadline-card">
              <div class="deadline-label">公示期截止</div>
              <div class="deadline-date">{{ publicityDeadline || '—' }}</div>
            </div>
          </div>
        </div>
        <div class="publicity-info">
          <div class="info-left">
            <p class="intro">现就证书信息进行公示，请务必仔细核对：</p>
            <div class="info-row">
              <img src="@/assets/gsfinish.png" width="20" height="20" />
              <span>信息更正：如发现信息有误需修改，请于公示期内提交加盖所属公司公章的申请说明</span>
            </div>
            <div class="info-row">
              <img src="@/assets/gsfinish.png" width="20" height="20" />
              <span>
                信息确认：如确认无误，请点击下方
                <span class="highlight">【确认无误】</span>
                完成提交。
              </span>
            </div>
          </div>
        </div>
        <table class="info-table">
          <tr v-for="row in publicityTableRows" :key="row.label">
            <td class="cell-label">{{ row.label }}</td>
            <td class="cell-value">{{ row.value }}</td>
          </tr>
        </table>
        <div class="special-tip">
          特别提示：公示期截止后，系统将自动锁定信息并进入制证流程（盖章发放）。一旦生成证书，将视为本单位确认无误，后续不再受理任何更正请求。
        </div>

        <div v-if="showActions" class="action-row">
          <el-button class="btn-modify" :disabled="!canModify" @click="mode = 'modify'">申请修改</el-button>
          <el-button type="primary" class="btn-confirm" :disabled="!canConfirm" :loading="confirming" @click="confirmPublicity">
            确认无误
          </el-button>
        </div>
        <div v-if="confirmTip" class="action-tip">{{ confirmTip }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import AllHeader from '../components/Modal/AllHeader.vue'
import { DeclareDetails, SubmitModifyRequest, AwardLogCheckedLogs } from '../utils/api.js'
import axios from 'axios'

export default {
  name: 'PublicityConfirm',
  components: { AllHeader },
  data() {
    const uploadBase = process.env.NODE_ENV === 'development' ? 'https://test-dev.welamp.cn/api/home' : '/api/home';
    return {
      awardLogId: null,
      awardLog: null,
      auditLogs: [],
      publicityDeadline: '',
      publicityPeriod: null,
      mode: 'view',
      confirming: false,
      uploadUrl: `${uploadBase}/upload/file/award_log`,
      submitting: false,
      token: '',
      modifyRequest: {
        contact: '',
        phone: '',
        reason: '',
        fileList: [],
        file_urls: [],
      },
      rejectReasonVisible: false,
    }
  },
  computed: {
    baseURL() {
      return process.env.NODE_ENV === 'development' ? 'https://test-dev.welamp.cn/api/home' : '/api/home'
    },
    canConfirm() {
      if (!this.awardLog) return false;
      if (this.awardLog.is_out == 1) return false;
      if (this.awardLog.has_pending_modify) return false;
      return String(this.awardLog.publicity_status) === '6';
    },
    canModify() {
      if (!this.awardLog) return false;
      if (this.awardLog.is_out == 1) return false;
      if (this.awardLog.has_pending_modify) return false;
      // 有公示期则要求在公示期内
      if (this.publicityPeriod && this.publicityPeriod[0] && this.publicityPeriod[1]) {
        const today = new Date();
        const start = this.parseLocalDateTime(this.publicityPeriod[0], '00:00:00');
        const end = this.parseLocalDateTime(this.publicityPeriod[1], '23:59:59');
        return today >= start && today <= end && String(this.awardLog.publicity_status) === '6';
      }
      return String(this.awardLog.publicity_status) === '6';
    },
    confirmTip() {
      if (!this.awardLog) return '';
      if (this.awardLog.is_out == 1) return '淘汰单位无需确认';
      if (this.awardLog.has_pending_modify) return '已提交修改申请，待处理完成后再确认';
      if (String(this.awardLog.publicity_status) !== '6') return '当前记录无需确认或已完成确认';
      return '';
    },
    latestAuditProgress() {
      const latestLog = this.auditLogs && this.auditLogs.length ? this.auditLogs[0] : null
      if (latestLog) {
        const parts = [latestLog.step, latestLog.checkedStatus, latestLog.checkedAt].filter(Boolean)
        return parts.length ? parts.join(' / ') : '暂无审核进度'
      }
      if (!this.awardLog) return '暂无审核进度'
      if (this.awardLog.has_pending_modify) return '申请修改待审核'
      if (String(this.awardLog.publicity_status) === '7') return '企业已确认'
      if (String(this.awardLog.publicity_status) === '6') return '公示证书信息'
      return '暂无审核进度'
    },
    latestAuditDisplay() {
      const latestLog = this.auditLogs && this.auditLogs.length ? this.auditLogs[0] : null
      if (latestLog) {
        const node = latestLog.step || ''
        const status = latestLog.checkedStatus || ''
        const time = latestLog.checkedAt || ''
        const main = `${node}${status ? '-' + status : ''}`.trim()
        return `${main}${time ? ' ' + time : ''}`.trim() || '暂无审核进度'
      }
      if (!this.awardLog) return '暂无审核进度'
      if (this.awardLog.has_pending_modify) return '公示证书信息-申请修改'
      if (String(this.awardLog.publicity_status) === '7') return '确认企业信息-已确认'
      if (String(this.awardLog.publicity_status) === '6') return '公示证书信息'
      return '暂无审核进度'
    },
    showRejectReasonBtn() {
      const latestLog = this.auditLogs && this.auditLogs.length ? this.auditLogs[0] : null
      if (!latestLog) return false
      const status = latestLog.checkedStatus || ''
      return status.includes('驳回') && !!latestLog.checkedRemark
    },
    latestRejectReason() {
      const latestLog = this.auditLogs && this.auditLogs.length ? this.auditLogs[0] : null
      return latestLog ? latestLog.checkedRemark : ''
    },
    reviewResultDisplay() {
      const log = this.awardLog || {};
      const awardId = Number(log.award_id);
      if (awardId === 17) {
        const level = log.review_level || '';
        const map = {
          '特级': '特等',
          '一级': '一等',
          '二级': '二等',
          '三级': '三等',
        };
        if (level) return map[level] || level;
        return log.review_result || '-';
      }
      if (awardId === 13) {
        const level = log.review_level || '';
        if (log.review_result) return log.review_result;
        if (level && level !== '待评审') return level;
        return '-';
      }
      return log.review_result || '-';
    },
    projectNameDisplay() {
      const log = this.awardLog || {};
      const content = log.content || {};
      return (
        content.project_title ||
        content.project_name ||
        (content.info && (content.info.msg1 || content.info.projectNname || content.info.name || content.info.title)) ||
        (content.Contractorinfo && content.Contractorinfo.projectNname) ||
        log.project_name ||
        '-'
      );
    },
    contractorDisplay() {
      const log = this.awardLog || {};
      const content = log.content || {};
      return (
        (content.info && (content.info.msg7 || content.info.unit || content.info.company)) ||
        content.company ||
        content.unit ||
        (content.essinfo && (content.essinfo.unit || content.essinfo.company)) ||
        (log.user && (log.user.enterprise_name || log.user.name)) ||
        '-'
      );
    },
    mainPeopleDisplay() {
      const log = this.awardLog || {};
      const content = log.content || {};
      return (
        (content.info && (content.info.msg17 || content.info.msg11 || content.info.msg14)) ||
        content.main_people ||
        content.main_person ||
        content.author_names ||
        content.leader ||
        content.members ||
        content.group_people ||
        content.group_member ||
        content.member ||
        '-'
      );
    },
    showActions() {
      if (!this.awardLog) return false;
      if (this.awardLog.has_pending_modify) return false;
      if (this.awardLog.is_out == 1) return false;
      return String(this.awardLog.publicity_status) === '6';
    },
    topicNameDisplay() {
      const log = this.awardLog || {};
      const content = log.content || {};
      return (
        content.project_title ||
        content.topic_name ||
        content.subject_name ||
        content.project_topic ||
        content.name ||
        (content.info && (content.info.project_title || content.info.topic_name || content.info.subject_name || content.info.name)) ||
        '-'
      );
    },
    unitNameDisplay() {
      const log = this.awardLog || {};
      const content = log.content || {};
      return (
        content.company ||
        content.unit ||
        (content.info && (content.info.company || content.info.unit || content.info.msg7)) ||
        (log.user && (log.user.enterprise_name || log.user.name)) ||
        '-'
      );
    },
    groupNameDisplay() {
      const log = this.awardLog || {};
      const content = log.content || {};
      return (
        content.group ||
        content.group_name ||
        content.group_title ||
        (content.info && (content.info.group || content.info.group_name || content.info.group_title)) ||
        '-'
      );
    },
    groupMembersDisplay() {
      const log = this.awardLog || {};
      const content = log.content || {};
      return (
        content.group_people ||
        content.group_member ||
        content.members ||
        content.member ||
        content.main_people ||
        '-'
      );
    },
    publicityTableRows() {
      if (Number(this.awardLog && this.awardLog.award_id) === 17) {
        return [
          { label: '课题名称', value: this.topicNameDisplay },
          { label: '单位名称', value: this.unitNameDisplay },
          { label: '工程名称', value: this.projectNameDisplay },
          { label: '小组名称', value: this.groupNameDisplay },
          { label: '小组成员', value: this.groupMembersDisplay },
        ];
      }
      return [
        { label: '工程名称', value: this.projectNameDisplay },
        { label: '承建单位', value: this.contractorDisplay },
        { label: '主要完成人', value: this.mainPeopleDisplay },
      ];
    },
  },
  mounted() {
    if (typeof window !== 'undefined' && window.localStorage) {
      this.token = window.localStorage.getItem('TOKEN') || ''
    }
    this.awardLogId = this.$route.query.log_id
    if (this.awardLogId) {
      this.fetchLog()
    } else {
      this.$message.error('缺少申报记录标识')
      this.$router.replace({ path: '/member/Declar_record', query: { name: '申报记录' } })
    }
  },
  methods: {
    parseLocalDateTime(dateStr, timeStr = '00:00:00') {
      if (!dateStr) return null
      const normalized = String(dateStr).trim().replace(/\//g, '-')
      const [year, month, day] = normalized.split('-').map(v => Number(v))
      const [hour, minute, second] = String(timeStr).split(':').map(v => Number(v))
      if (!year || !month || !day) return null
      return new Date(year, month - 1, day, hour || 0, minute || 0, second || 0)
    },
    debugPublicityState(source = 'unknown') {
      if (typeof window === 'undefined') return
      const log = this.awardLog || null
      const now = new Date()
      const periodStart = this.publicityPeriod && this.publicityPeriod[0]
        ? this.parseLocalDateTime(this.publicityPeriod[0], '00:00:00')
        : null
      const periodEnd = this.publicityPeriod && this.publicityPeriod[1]
        ? this.parseLocalDateTime(this.publicityPeriod[1], '23:59:59')
        : null
      const inPublicityPeriod = periodStart && periodEnd ? (now >= periodStart && now <= periodEnd) : null
      const showActionsReason = !log
        ? 'awardLog_missing'
        : log.has_pending_modify
          ? 'pending_modify_request'
          : log.is_out == 1
            ? 'is_out'
            : String(log.publicity_status) !== '6'
              ? `publicity_status_${log.publicity_status}`
              : 'ok'
      const canModifyReason = !log
        ? 'awardLog_missing'
        : log.is_out == 1
          ? 'is_out'
          : log.has_pending_modify
            ? 'pending_modify_request'
            : periodStart && periodEnd && !inPublicityPeriod
              ? 'outside_publicity_period'
              : String(log.publicity_status) !== '6'
                ? `publicity_status_${log.publicity_status}`
                : 'ok'

      console.log('[PublicityConfirm] modify-debug', {
        source,
        awardLogId: this.awardLogId,
        mode: this.mode,
        showActions: this.showActions,
        showActionsReason,
        canModify: this.canModify,
        canModifyReason,
        canConfirm: this.canConfirm,
        confirmTip: this.confirmTip,
        publicityDeadline: this.publicityDeadline,
        publicityPeriod: this.publicityPeriod,
        now: now.toISOString(),
        periodStart: periodStart ? periodStart.toISOString() : null,
        periodEnd: periodEnd ? periodEnd.toISOString() : null,
        inPublicityPeriod,
        awardLog: log ? {
          id: log.id,
          award_id: log.award_id,
          status: log.status,
          publicity_status: log.publicity_status,
          is_out: log.is_out,
          has_pending_modify: log.has_pending_modify,
          review_result: log.review_result,
          review_level: log.review_level,
        } : null,
      })
    },
    resolveAwardTitle() {
      const titleMap = {
        13: '建筑与市政工程绿色施工评价',
        17: '工程建设质量管理小组竞赛活动',
        21: '贵州省工程建设工法评定',
      }
      const awardId = Number(this.awardLog && this.awardLog.award_id)
      return (this.awardLog && this.awardLog.award && this.awardLog.award.title)
        || this.awardLog?.award_title
        || titleMap[awardId]
        || '申报记录'
    },
    goBack() {
      const awardId = this.awardLog?.award_id;
      const awardTitle = this.awardLog?.award?.title;
      const query = { name: '申报记录' };
      if (awardId) {
        query.baid = awardId;
      }
      if (awardTitle) {
        query.btitle = awardTitle;
      }
      this.$router.push({ path: '/member/Declar_record', query });
    },
    async fetchLog() {
      try {
        const res = await DeclareDetails(this.awardLogId)
        this.awardLog = res
        this.publicityDeadline = res.publicity_deadline || ''
        this.publicityPeriod = res.publicity_period || null
        this.fetchAuditLogs()
        if (res.has_pending_modify) {
          this.mode = 'view'
        }
        this.debugPublicityState('fetchLog_success')
      } catch (e) {
        this.$message.error('获取申报信息失败')
        console.log('[PublicityConfirm] fetchLog_error', {
          awardLogId: this.awardLogId,
          error: e,
        })
      }
    },
    async fetchAuditLogs() {
      if (!this.awardLogId) return
      try {
        const res = await AwardLogCheckedLogs(this.awardLogId)
        this.auditLogs = Array.isArray(res) ? res : []
      } catch (e) {
        this.auditLogs = []
      }
    },
    goAuditLogs() {
      if (!this.awardLogId) return
      this.$router.push({
        path: '/gflogs',
        query: {
          logid: this.awardLogId,
          awardid: this.awardLog?.award_id || '',
          award_batch_id: this.awardLog?.award_batch_id || '',
          title: this.resolveAwardTitle(),
        },
      })
    },
    openRejectReason() {
      this.rejectReasonVisible = true
    },
    closeRejectReason(done) {
      this.rejectReasonVisible = false
      if (typeof done === 'function') done()
    },
    onUploadSuccess(response, file, fileList) {
      this.modifyRequest.fileList = fileList
      const url = response && response.data && response.data.url
      this.modifyRequest.file_urls = fileList
        .filter(f => f.response && f.response.data)
        .map(f => f.response.data.url)
      if (url && !this.modifyRequest.file_urls.includes(url)) {
        this.modifyRequest.file_urls.push(url)
      }
    },
    onUploadRemove(file, fileList) {
      this.modifyRequest.fileList = fileList
      this.modifyRequest.file_urls = fileList
        .filter(f => f.response && f.response.data)
        .map(f => f.response.data.url)
    },
    onUploadError() {
      this.$message.error('文件上传失败')
    },
    async submitModifyRequest() {
      if (!this.canModify) {
        this.debugPublicityState('submitModifyRequest_blocked')
        this.$message.warning('当前不允许提交修改申请')
        return
      }
      if (!this.modifyRequest.contact.trim()) {
        this.$message.warning('请输入联系人')
        return
      }
      if (!this.modifyRequest.phone.trim()) {
        this.$message.warning('请输入联系电话')
        return
      }
      if (!this.modifyRequest.reason.trim()) {
        this.$message.warning('请输入申请说明')
        return
      }
      try {
        await this.$confirm(
          '提交后不可修改，是否确认提交？',
          '温馨提示',
          {
            confirmButtonText: '确认提交',
            cancelButtonText: '再检查一下',
            type: 'warning',
          }
        )
      } catch (e) {
        return
      }
      this.submitting = true
      try {
        await SubmitModifyRequest(this.awardLogId, {
          contact_name: this.modifyRequest.contact,
          contact_phone: this.modifyRequest.phone,
          reason: this.modifyRequest.reason,
          file_urls: JSON.stringify(this.modifyRequest.file_urls),
        })
        this.$message.success('申请已提交，请等待工作人员处理')
        this.mode = 'view'
        this.fetchLog()
      } catch (err) {
        this.$message.error(err || '提交失败')
      } finally {
        this.submitting = false
      }
    },
    async confirmPublicity() {
      if (!this.awardLogId) return
      if (!this.canConfirm) {
        this.debugPublicityState('confirmPublicity_blocked')
        this.$message.warning(this.confirmTip || '当前不允许确认')
        return
      }
      try {
        await this.$confirm(
          '重要提示：证书信息提交确认后将不可修改。请您务必仔细核查证书各项关键信息。是否确认提交？',
          '温馨提示',
          {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning',
          }
        )
      } catch (e) {
        return
      }
      this.confirming = true
      try {
        await axios.post(`${this.baseURL}/award_log/confirm_publicity/${this.awardLogId}`, {}, {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('TOKEN'), 'Content-Type': 'application/json' },
        })
        this.$message.success('已确认无误，等待证书正式发放')
        this.fetchLog()
      } catch (e) {
        this.$message.error('确认失败，请重试')
      } finally {
        this.confirming = false
      }
    },
  },
}
</script>

<style scoped>
.publicity-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}
.publicity-table {
  padding: 16px 10px;
  background: #eff4ff;
  border-radius: 4px;
  margin-bottom: 20px;
}
.table-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 0;
}
.table-head__result {
  display: flex;
  align-items: center;
  min-width: 0;
}
.table-head__icon {
  width: 28px;
  height: 28px;
  margin-right: 8px;
  flex-shrink: 0;
}
.table-head__label {
  font-size: 20px;
  color: #262626;
  font-weight: 500;
}
.table-head__value {
  font-size: 20px;
  color: #262626;
  font-weight: 500;
  margin-left: 2px;
}
.info-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
  background: #fff;
}
.info-table td {
  border: 1px solid #d9d9d9;
  padding: 12px 16px;
  vertical-align: middle;
}
.cell-label {
  width: 180px;
  background: #fafafa;
  color: #333;
  font-weight: 600;
}
.cell-value {
  color: #333;
}
.publicity-info {
  display: flex;
  gap: 24px;
  font-size: 18px;
  color: #262626;
  margin-bottom: 20px;
}
.info-left {
  flex: 1;
}
.progress-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 8px;
  background: #fff8f1;
  border: 2px solid #f0e2c9;
  border-radius: 8px;
  flex: 1;
}
.progress-text {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  line-height: 1.4;
  font-size: 18px;
}
.progress-label {
  font-weight: 600;
  color: #94602f;
}
.progress-value {
  color: #262626;
}
.progress-actions {
  display: flex;
  align-items: center;
  gap: 40px;
  flex-shrink: 0;
}
.btn-log {
  color: #194abe;
  border: 2px solid #194abe;
  background: #ffffff;
  border-radius: 8px;
  font-size: 15px;
  padding: 8px;
  height: auto;
}
.btn-reject {
  color: #ff505c;
  border: 2px solid #ff505c;
  background: #ffffff;
  border-radius: 8px;
  font-size: 15px;
  padding: 8px;
  height: auto;
}
.intro {
  font-size: 18px;
  margin-bottom: 12px;
}
.info-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 16px;
  margin-bottom: 10px;
}
.highlight {
  font-weight: 500;
}
.info-right {
  width: 138px;
  height: 88px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(30, 57, 149, 0.08);
  border: 1px solid #e9eef6;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.deadline-card {
  text-align: center;
  min-width: 140px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-shrink: 0;
}
.deadline-label {
  font-size: 16px;
  color: #194abe;
  line-height: 1;
}
.deadline-date {
  font-size: 16px;
  color: #194abe;
  line-height: 1;
  margin-top: 18px;
}
.special-tip {
  margin-top: 21px;
  font-size: 16px;
  color: #ff505c;
  line-height: 26px;
}
.modify-panel {
  font-size: 16px;
  color: #262626;
  display: flex;
  flex-direction: column;
  gap: 28px;
  margin-bottom: 26px;
}
.field-group {
  display: flex;
  align-items: center;
  gap: 12px;
}
.field-group label {
  width: 120px;
  font-size: 16px;
  color: #262626;
}
.field-group span {
  font-size: 16px;
  color: #262626;
}
.field-group .el-input__inner {
  width: 360px;
  border-color: #cccccc;
  border-radius: 4px;
}
.file-upload .file-box {
  width: 110px;
  height: 110px;
  padding: 6px;
  background: #f7f7f7;
  border: 1px dashed #cccccc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 4px;
  box-sizing: border-box;
}
.file-box img {
  width: 44px;
  height: 44px;
}
.file-note {
  margin-top: 10px;
  font-size: 12px;
  color: #f56c6c;
  text-align: center;
  line-height: 1.2;
}
.yellow-box {
  background: #fef8ef;
  border-radius: 6px;
  padding: 16px;
  font-size: 18px;
  color: #262626;
  line-height: 1.6;
  text-align: left;
}
.reject-reason-box {
  min-height: 80px;
  white-space: pre-wrap;
}
.submit-btn {
  margin-top: 48px;
  padding: 5px 56px;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  background: #194abe;
  border-radius: 4px;
}
.preview-container {
  margin-bottom: 36px;
  display: flex;
  justify-content: center;
  width: 100%;
}
.preview-images {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  width: 100%;
}
.preview-images img {
  width: 100%;
  max-width: none;
  border: 1px solid #eaeaef;
  border-radius: 6px;
  background: #ffffff;
}
.preview-placeholder {
  width: 100%;
  max-width: none;
  height: 520px;
  border: 1px dashed #cfd3db;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}
.action-row {
  display: flex;
  gap: 24px;
  margin-top: 69px;
  margin-bottom: 36px;
  justify-content: center;
}
.modify-panel .action-row {
  margin-top: 20px;
}
.btn-modify,
.btn-confirm {
  font-size: 18px;
  font-weight: bold;
  padding: 10px 48px;
  border-radius: 4px;
}
.btn-modify {
  color: #2b5bff;
  background: #e6edff;
  border: none;
}
.btn-confirm {
  background: #2b5bff;
  color: #ffffff;
  border: none;
}
.action-tip {
  text-align: center;
  color: #999;
  margin-bottom: 24px;
}
@media (max-width: 768px) {
  .progress-bar {
    align-items: stretch;
    flex-direction: column;
  }
  .table-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .deadline-card {
    align-items: flex-start;
    text-align: left;
  }
}
</style>
